import { Component, Input } from '@angular/core';
import { ModalPrivacityComponent } from '../../modal-privacity/modal-privacity.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'general-chebox',
  templateUrl: './general-chebox.component.html',
  styleUrl: './general-chebox.component.scss'
})
export class GeneralCheboxComponent {

  @Input() form!: FormGroup;
  @Input() controlName!: string;
  @Input() useAlternativeText: boolean = false; // Por defecto usa el texto original

  constructor(
    private modalService: NgbModal,
  ) {
  }

  openModal() {
    this.modalService.open(ModalPrivacityComponent, { size: 'lg' });
  }
}
